module.exports = __webpack_public_path__ + "static/media/robot walkng.ed17c54b.gif";